import { Component, inject } from '@angular/core';

import { AppPreferences } from '../../../core/services/app-preferences';
import { AppIcon, AppIconName } from '../../../shared/app-icon/app-icon';

type Feature = {
  key: string;
  icon: AppIconName;
};

@Component({
  selector: 'app-features-section',
  imports: [AppIcon],
  templateUrl: './features-section.html',
  styleUrl: './features-section.scss',
})
export class FeaturesSection {
  readonly preferences = inject(AppPreferences);
  readonly features: Feature[] = [
    { key: 'offers', icon: 'multiple-offers' },
    { key: 'online', icon: 'online' },
    { key: 'fast', icon: 'quick-procedures' },
    { key: 'support', icon: 'support-every-step' },
  ];
}
